export const POSITION_FIELD = 'position'
export const STATUS_FIELD = 'status'

export const getDefaultValues = () => ({
  [POSITION_FIELD]: null,
  [STATUS_FIELD]: null,
})
